/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './doctor-diaglab-association.reducer';

export const DoctorDiaglabAssociation = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const doctorDiaglabAssociationList = useAppSelector(state => state.doctorDiaglabAssociation.entities);
  const loading = useAppSelector(state => state.doctorDiaglabAssociation.loading);
  const totalItems = useAppSelector(state => state.doctorDiaglabAssociation.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="doctor-diaglab-association-heading" data-cy="DoctorDiaglabAssociationHeading">
        <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.home.title">Doctor Diaglab Associations</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/doctor-diaglab-association/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.home.createLabel">
              Create new Doctor Diaglab Association
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.doctorDiaglabAssociation.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {doctorDiaglabAssociationList && doctorDiaglabAssociationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('joiningDate')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.joiningDate">Joining Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('joiningDate')} />
                </th>
                <th className="hand" onClick={sort('leavingDate')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.leavingDate">Leaving Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('leavingDate')} />
                </th>
                <th className="hand" onClick={sort('dutyStartTime')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.dutyStartTime">Duty Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dutyStartTime')} />
                </th>
                <th className="hand" onClick={sort('dutyEndTime')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.dutyEndTime">Duty End Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dutyEndTime')} />
                </th>
                <th className="hand" onClick={sort('permanent')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.permanent">Permanent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('permanent')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('association')}>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.association">Association</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('association')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.doctor">Doctor</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.lab">Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {doctorDiaglabAssociationList.map((doctorDiaglabAssociation, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/doctor-diaglab-association/${doctorDiaglabAssociation.id}`} color="link" size="sm">
                      {doctorDiaglabAssociation.id}
                    </Button>
                  </td>
                  <td>{doctorDiaglabAssociation.joiningDate}</td>
                  <td>{doctorDiaglabAssociation.leavingDate}</td>
                  <td>{doctorDiaglabAssociation.dutyStartTime}</td>
                  <td>{doctorDiaglabAssociation.dutyEndTime}</td>
                  <td>{doctorDiaglabAssociation.permanent ? 'true' : 'false'}</td>
                  <td>{doctorDiaglabAssociation.active ? 'true' : 'false'}</td>
                  <td>{doctorDiaglabAssociation.cursor}</td>
                  <td>{doctorDiaglabAssociation.lastUpdated}</td>
                  <td>{doctorDiaglabAssociation.microSec}</td>
                  <td>{doctorDiaglabAssociation.timestampEntry}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AssociationType.${doctorDiaglabAssociation.association}`} />
                  </td>
                  <td>
                    {doctorDiaglabAssociation.doctor ? (
                      <Link to={`/doctor/${doctorDiaglabAssociation.doctor.id}`}>{doctorDiaglabAssociation.doctor.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {doctorDiaglabAssociation.lab ? (
                      <Link to={`/diag-lab/${doctorDiaglabAssociation.lab.id}`}>{doctorDiaglabAssociation.lab.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/doctor-diaglab-association/${doctorDiaglabAssociation.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/doctor-diaglab-association/${doctorDiaglabAssociation.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/doctor-diaglab-association/${doctorDiaglabAssociation.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.home.notFound">
                No Doctor Diaglab Associations found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={doctorDiaglabAssociationList && doctorDiaglabAssociationList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DoctorDiaglabAssociation;
